import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/providers/general/general.service';
import { OrganisationService } from 'src/app/providers/setups/organisation/organisation.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { SysLogsComponent } from '../sys-logs/sys-logs.component';
declare let $: any;
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  @Input() entitytypeid;
  @Input() sourceid;
  @Input() config;
  @Input() logTable: any;
  @ViewChild(SysLogsComponent) sysLogs: SysLogsComponent;
  @Output() callSyslogsAddress = new EventEmitter<string>();
  // this.empLogsAdd();
  myContact: any = [];
  response: any = [];
  subAdd = false;
  contactForm: FormGroup;
  loading;
  dynamicHeader: any ;
  constructor(
    private formBuilder: FormBuilder,
    public httpOrg: OrganisationService,
    private genhttp: GeneralService,
    private notifyService: NotificationService) { }

  ngOnInit(): void {
    this.ContactFormField();
    this.getEntityContact();
  }
  empLogsAdd(): void {
    this.callSyslogsAddress.emit('');
  }
  getEntityContact(): void {
    this.genhttp.getEntityContact(this.entitytypeid, this.sourceid).subscribe(data => {
      this.response = data;
      if (this.response.status === false) {

      } else if (this.response.status === true) {
        this.myContact = this.response.data;
      }
    });
  }

  addContact(id, header): void {
    this.dynamicHeader = header;
    this.ContactFormField();
    $(id).modal({ backdrop: 'static', keyboard: false});
  }

  ContactFormField(): void {
    this.contactForm = this.formBuilder.group({
      cont_id: [''],
      source_id: [this.sourceid],
      entity_type_id: [this.entitytypeid],
      cont_person_name: ['', Validators.required],
      contact_1: ['', Validators.required],
      contact_2: [''],
      contact_3: [''],
      fax: [''],
      email_1: ['' ],
      email_2: [''],
      is_primary: [''],
      is_secondary: [''],
      table : [this.logTable],
    });
  }

   // tslint:disable-next-line: typedef
   get addErrorMsg() { return this.contactForm.controls; }

  editContact(id , header): void {
    this.dynamicHeader = header;
    this.httpOrg.editContact(id).subscribe(data => {
      this.response = data;
      if (this.response.status === true) {
        this.contactForm.patchValue({
          cont_id: this.response.data.cont_id,
          source_id: this.response.data.source_id,
          cont_person_name: this.response.data.cont_person_name,
          contact_1: this.response.data.cont_1,
          contact_2: this.response.data.cont_2,
          contact_3: this.response.data.cont_3,
          fax: this.response.data.fax,
          email_1: this.response.data.email_1,
          email_2: this.response.data.email_2,
          is_primary: this.response.data.is_primary,
          is_secondary: this.response.data.is_secondary,
          table : this.logTable
        });
        $('#zero_add_contact').modal('show');
      }
    });
  }

  onSubmitContact(): void {
    this.subAdd = true;
    if (this.contactForm.invalid) {
      return;
    } else {
      this.httpOrg.addContact(this.contactForm.value).subscribe(data => {
        console.log(data);
        this.response = data;
        if (this.response.status === false) {
          this.notifyService.showInfo(this.response.msg, 'Info!');
        } else if (this.response.status === true) {
          $('#zero_add_contact').modal('hide');
          this.notifyService.showSuccess(this.response.msg, 'Success!');
          this.getEntityContact();
          this.empLogsAdd();
        }
      });
    }
  }

  deleteContact(id): void {
    this.httpOrg.deleteContact(id).subscribe(data => {
      console.log(data);
      this.response = data;
      if (this.response.status === false) {
        this.notifyService.showInfo(this.response.msg, 'Info!');
      } else if (this.response.status === true) {
        this.notifyService.showSuccess(this.response.msg, 'Success!');
        this.myContact = this.myContact.filter(val => val.cont_id !== id);
        this.empLogsAdd();
      }
    });
  }

  onResetContact(): void {
    this.ContactFormField();
  }

}
